import {createSelector} from 'reselect';

import {getNavigation, getListingPage} from './store';
import {getIsMobile} from './system';
import getLayout, {SECTIONS} from './layout';

const getNavTabsDynamic = createSelector(
    [getLayout],
    (layout) => {
        let navItemsArray = [];

        // if navLabel is defined, include it in the nav bar
        layout.order.forEach(({name, navLabel}) => {
            if (navLabel) {
                navItemsArray.push({
                    id: name,
                    href: `#${name}`,
                    label: navLabel
                });
            }
        });

        return navItemsArray;
    }
);

const getTripSummaryVisible = createSelector(
    [getListingPage],
    (listing) => listing.tripSummaryVisible
);

const getNavActiveTabIndex = createSelector(
    [getNavigation],
    (navigation) => navigation.navActiveTabIndex
);

const getNavData = createSelector(
    [getNavTabsDynamic, getNavActiveTabIndex, getIsMobile, getTripSummaryVisible],
    (navTabs, activeIndex, isMobile, tripSummaryVisible) => ({
        navTabs,
        activeIndex,
        isMobile,
        tripSummaryVisible
    })
);

const NAV_TABS = SECTIONS;

export default getNavData;
export {getNavData, NAV_TABS};
